module.exports = __webpack_public_path__ + "static/img/图片9.0a129ba0.png";